module.exports = __webpack_public_path__ + "be.no2.3fe8c6b6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/be.no2.jpg
// module id = AxKc
// module chunks = 0